module.exports = __webpack_public_path__ + "img/NokiaBellLogo2.ab8b877b.jpg";